import React from "react";
import '../styles/HeaderFooterReport.css';

// Corregir la ruta de importación de la imagen
// Asumiendo que está en src/assets/images/
import logoFundacion from "../assets/images/login-image.png";

const HeaderReport = () => {
    return (
        <header className="report-header">
            <div className="header-content">
                <img 
                    src={logoFundacion} 
                    alt="Logo Fundación" 
                    className="report-logo" 
                />
                
                <div className="report-text">
                    <h1>Fundación Ecuatoriana para la Ayuda al Síndrome de Turner</h1>
                    <h3>Acuerdo Ministerial 237 MIES </h3>
                    <h4>http://www.turnerecuador.org</h4>
                </div>
            </div> 
            <hr />
        </header>
    );
};

export default HeaderReport;
